export const IM_GIFT_BAG_HALF_CARD_IMAGE_URL = "Giftables/Gift%20bag.png";
export const IM_GIFT_BAG_HALF_CARD_BACKGROUND_IMAGE_URL = "Giftables/Add%20bag%20bg.png";
export const TEXTS = {
    HEADING: "Get the below items delivered in a Gift bag",
    PRIMARY_BUTTON_TEXT: "Yes, deliver my items in a gift bag!",
    SECONDARY_BUTTON_TEXT: "No, send the gift bag separately",
};

const PREFIX = "im-gift-bag-halfcard";
export const IM_GIFTBAG_HALFCARD_DATA_TEST_IDS = {
    CONTAINER: `${PREFIX}-container`,
    IMAGE_CONTAINER: `${PREFIX}-image-container`,
    HEADING: `${PREFIX}-heading`,
    ITEM_LIST: `${PREFIX}-item-list`,
    PRIMARY_BUTTON: `${PREFIX}-primary-button`,
    SECONDARY_BUTTON: `${PREFIX}-secondary-button`,
    DISCLAIMER: `${PREFIX}-disclaimer`,
};

// Carousel configuration constants
export const CAROUSEL_CONFIG = {
    CARD_WIDTH: 200,
    GAP: 16,
    AUTO_SCROLL_INTERVAL: 3000,
} as const;
